export default function Training() {
  const courses = [
    {
      title: 'Professional Yacht Delivery',
      level: 'Beginner',
      duration: '3 Days',
      description: 'Expert yacht transfer services with meticulous planning and execution across all distances',
      features: [
        'Worldwide Relocation',
        'Pre-Departure Technical Inspection',
        'Qualified Crew Placement',
        'Real-Time Tracking and Reporting',
        'Vessel Preservation',
        'Insurance Compliance'
      ]
    },
    {
      title: 'Professional Skipper Service',
      level: 'Intermediate',
      duration: '5 Days',
      description: 'Expert onboard management for cruising or racing, balancing technical performance with safety for a seamless experience.',
      features: [
        'Leisure and Regatta Command',
        'Local Knowledge and Port Logistics',
        'Performance Optimization and Sail Trim',
        'Safety and Emergency Management',
        'Crew Coordination and Training',
        'International Cruising and Race Charter Knowledge'
      ]
    },
    {
      title: 'Navigation/Weather Routing',
      level: 'Advanced',
      duration: '7 Days',
      description: 'Advanced navigation strategies and comprehensive weather routing for optimal passage planning.',
      features: [
        'Passage Planning',
        'Meteorological Data & Analysis',
        'Optimum Routing',
        '24/7 Remote & Onboard Support',
        'GRIB Data & Satellite Overlay',
        'Competitive regatta preparation'
      ]
    }
  ];

  return (
    <section id="training" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Expertise on every mile. We offer professional yacht delivery, elite skipper services, and advanced navigational solutions designed for both racing and long-distance passages.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300">
              <div className="bg-gradient-to-br from-slate-700 to-slate-800 p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">{course.title}</h3>
              </div>
              <div className="p-6">
                <p className="text-gray-700 mb-6 leading-relaxed">
                  {course.description}
                </p>
                <ul className="space-y-3">
                  {course.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-amber-600 text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
